import { ResourceProps } from "react-admin";
import Icon from "@mui/icons-material/NightShelter";
import { Resource } from "../../enums";
import ListScreen from "./list";
import { CreateScreen } from "./create";
import { EditScreen } from "./edit";

const groupEvents: ResourceProps = {
  name: Resource.GROUP_EVENTS,
  icon: Icon,
  list: ListScreen,
  create: CreateScreen,
  edit: EditScreen,
  options: {
    label: "Group Event Types",
  },
};

export default groupEvents;
